import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: '¿Necesito saber de marketing?',
    answer: 'No. El sistema te guía paso a paso y la IA hace el trabajo pesado. Vos solo cargás tu marca y elegís lo que más te gusta.'
  }, {
    question: '¿Esto es un PDF?',
    answer: 'No. Es una plataforma interactiva: entrás con tu usuario y generás tu propio material (creativos, copys, ángulos, segmentación). No es teoría, es tu campaña.'
  }, {
    question: '¿La IA publica sola en mis cuentas?',
    answer: 'En el ebook, vos generás y descargás todo tu material y lo publicás cuando quieras — tenés el control total. (Si querés que además se publique y optimice solo, eso está en nuestra plataforma completa mensual.)'
  }, {
    question: '¿Cómo accedo después de pagar?',
    answer: 'Te registrás en la plataforma con tu email. Para activar tu acceso, te contactamos por nuestro Telegram de soporte para validar tu compra. La activación puede demorar hasta 24 hs.'
  }, {
    question: '¿Sirve para mi rubro?',
    answer: 'Sí. La IA se adapta a tu nicho — desde servicios y comercios hasta e-commerce. Cuanto más específico cargás tu marca, mejor sale todo.'
  }, {
    question: '¿Puedo pedir el reembolso?',
    answer: 'Sí, tenés 7 días de garantía. Si no es para vos, te devolvemos tu dinero.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-38">
      <div className="max-w-3xl mx-auto px-4" data-id="element-39">
        <div className="text-center mb-12" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-41">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-2xl overflow-hidden transition-colors ${openIndex === index ? 'border-blue-200 bg-blue-50/30' : 'border-slate-200 bg-white'}`} data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-44">
                <span className="font-bold text-slate-900 pr-4" data-id="element-45">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-blue-600 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-46" />
              </button>
              <AnimatePresence data-id="element-47">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-48">
                    <div className="px-6 pb-6 text-slate-600 leading-relaxed" data-id="element-49">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}